module.exports = __webpack_public_path__ + "img/happy.fef15944.svg";